import { useCallback, useMemo } from 'react';

import { useJobsNwtTracking } from '@xing-com/crate-jobs-tracking';

const getJobTrackingCodeFromUrl = (url?: string): string => {
  if (!url) return '';

  const trackingParam = new URLSearchParams(
    url.substring(url.indexOf('?'))
  ).get('ijt');

  return trackingParam ?? '';
};

type ClickCallback = (e: React.MouseEvent<HTMLDivElement>) => void;
type LinkClickCallback = React.MouseEventHandler<HTMLAnchorElement>;

type HookProps = {
  isExternalJob: boolean;
  jobId: string;
  url?: string;
  clickCallback?: ClickCallback;
};

export const useJobTeaserClickExternalTracking = ({
  isExternalJob,
  jobId,
  url,
  clickCallback,
}: HookProps): LinkClickCallback | undefined => {
  const trackNwt = useJobsNwtTracking();
  const jobTrackingCode = useMemo(() => getJobTrackingCodeFromUrl(url), [url]);

  const invokeClickCallback = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      clickCallback?.(e as unknown as React.MouseEvent<HTMLDivElement>);
    },
    [clickCallback]
  );

  const clickWithExternalTracking = useCallback<LinkClickCallback>(
    (e) => {
      trackNwt({
        eventSchema: 'basic',
        event: 'viewed_screen',
        page: 'jobs/detail_external',
        context: 'auto_redirect',
        itemUrn: `surn:x-xing:jobs:posting:${jobId}`,
        entryPoint: `jobs_origin_${jobTrackingCode}`,
      });
      trackNwt({
        eventSchema: 'basic',
        event: 'job_detail_viewed',
        page: 'jobs/detail_external',
        context: 'auto_redirect',
        itemUrn: `surn:x-xing:jobs:posting:${jobId}`,
        entryPoint: `jobs_origin_${jobTrackingCode}`,
      });
      invokeClickCallback(e);
    },
    [invokeClickCallback, jobId, jobTrackingCode, trackNwt]
  );

  return isExternalJob
    ? clickWithExternalTracking
    : clickCallback
      ? invokeClickCallback
      : undefined;
};
